<template>
  <div class="table__header--no-top-border">
    <AutoComplete
      v-if="props.selectorType === 'autocomplete'"
      v-model="nameFilter"
      force-selection
      :min-length="3"
      :placeholder="props.townLabel"
      option-label="name"
      :suggestions="validTowns"
      @clear="clearFilter"
      @complete="({query: name}) => preUpdateTowns(name)"
      @item-select="({value: town}) => selectTown(town)"
    />
    <DataTable
      v-if="props.selectorType === 'datatable'"
      v-model:selection="selectedTown"
      :value="validTowns"
      selection-mode="single"
      scrollable
      scroll-height="20vh"
      @row-select="addTown"
    >
      <template #header>
        <div class="flex">
          <div class="w-full p-input-icon-right">
            <i class="pi pi-search" />
            <InputText
              id="town-search"
              type="search"
              class="w-11"
              placeholder="Buscar"
              :model-value="nameFilter"
              @update:model-value="preUpdateTowns"
            />
          </div>
          <div
            v-if="!props.multiple"
            class="mx-auto"
          >
            <Button
              icon="pi pi-plus"
              :disabled="!selectedTown"
              rounded
              raised
              @click="addTown"
            />
          </div>
        </div>
      </template>
      <Column
        field="name"
        header="Nombre"
        header-class="hidden"
      ></Column>
      <Column
        field="province"
        header="Provincia"
        header-class="hidden"
      ></Column>
      <Column
        v-if="!props.multiple"
        header="Añadir"
        header-class="hidden"
      >
        <template #body="{data}">
          <Button
            class="mc-row__button-sm"
            icon="pi pi-plus"
            rounded
            raised
            @click="rowAddTown(data)"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import AutoComplete from 'primevue/autocomplete';
import Column from 'primevue/column';
import Button from 'primevue/button';
import {searchTownName} from '@/api/town/town.api';
// #region Props, Emits
const props = defineProps({
  multiple: {
    type: Boolean,
    default: () => false,
  },
  townLabel: {
    type: String,
    default: () => 'Municipio',
  },
  selectorType: {
    type: String,
    default: () => 'datatable',
  },
});
const emit = defineEmits(['addTown', 'selectTown']);
// #endregion

// #region Params, Ref, Reactives, Computed
const nameFilter = ref('');
const selectedTown = ref(null);
const towns = ref([]);
const validTowns = computed(() => towns.value.filter((t) => {
  return !!t.coordinates &&
         !!t.coordinates[0] && !!t.coordinates[1];
}));
let timeout;
// #endregion

// #region Functions
function clearFilter() {
  nameFilter.value = '';
}
function preUpdateTowns(name) {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    updateTowns(name);
  }, 500);
}
async function updateTowns(name) {
  let res = [];
  if (name && name.length > 2) {
    res = await searchTownName(name);
  }
  towns.value = res;
}
function rowAddTown(data) {
  emit('addTown', data);
  selectedTown.value = null;
}
function addTown() {
  emit('addTown', selectedTown.value);
  selectedTown.value = null;
}
function selectTown(selectedTown) {
  emit('selectTown', selectedTown);
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose
defineExpose({
  clearFilter,
});
// #endregion
</script>

<style lang="scss" scoped>
  .table__header--no-top-border :deep(.p-datatable-header) {
    border: none;
  }
  .table__header--no-top-border :deep(.p-datatable-wrapper) {
    margin-left: 0;
    .p-selectable-row {
      height: 40px !important;
    }
  }
</style>
